<template>
  <section class="league-format-section" id="league-format">
    <div class="section-container">
      <div class="section-header">
        <h2 class="section-title">League Format Details</h2>
        <p class="section-subtitle">Understanding the Bad Boys Tru-Team Format and BCAPL Rules</p>
      </div>
      
      <LeagueFormatContent />
    </div>
  </section>
</template>

<script setup lang="ts">
import LeagueFormatContent from './LeagueFormatContent.vue';
</script>

<style scoped>
.league-format-section {
  padding: 80px 0;
  background: 
    linear-gradient(180deg, rgba(15, 23, 42, 0.9) 0%, rgba(30, 58, 138, 0.9) 100%),
    url('/images/billiards-3-1920w.webp');
  background-size: cover;
  background-position: center;
  background-attachment: fixed;
  position: relative;
  overflow: hidden;
}

.league-format-section::before {
  content: '';
  position: absolute;
  inset: 0;
  background: 
    radial-gradient(circle at 25% 25%, rgba(255, 184, 28, 0.08) 0%, transparent 50%),
    radial-gradient(circle at 75% 75%, rgba(59, 130, 246, 0.08) 0%, transparent 50%);
  z-index: 1;
}

.section-container {
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 24px;
  position: relative;
  z-index: 2;
}

.section-header {
  text-align: center;
  margin-bottom: 64px;
}

.section-title {
  color: var(--gold);
  font-size: 3rem;
  font-family: var(--font-heading);
  font-weight: 700;
  margin-bottom: 16px;
  text-shadow: 2px 2px 4px rgba(0, 0, 0, 0.3);
  position: relative;
}

.section-title::after {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 80px;
  height: 3px;
  background: linear-gradient(90deg, transparent, var(--gold), transparent);
  border-radius: 2px;
}

.section-subtitle {
  color: var(--cream);
  font-size: 1.2rem;
  opacity: 0.9;
  margin-top: 24px;
  line-height: 1.6;
}

/* Responsive Design */
@media (max-width: 768px) {
  .league-format-section {
    padding: 60px 0;
  }
  
  .section-container {
    padding: 0 16px;
  }
  
  .section-header {
    margin-bottom: 48px;
  }
  
  .section-title {
    font-size: 2.2rem;
  }
  
  .section-subtitle {
    font-size: 1.1rem;
  }
}

@media (max-width: 480px) {
  .section-title {
    font-size: 1.8rem;
  }
}
</style>
